module.exports = __webpack_public_path__ + "images/19132-EXT1-Cam05_2.1-32bcf9389cadc76eec0428e3015bb092.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Carousel_2/19132-EXT1-Cam05_2.1.jpg
// module id = 749
// module chunks = 0